import { useEditingStateWithCtx } from '@/atoms'
import {
  selectTrafficAreasListOptions,
  selectTrafficAreasListStructure,
  setListOptions,
} from '@/features/domain/lists'
import { useAppDispatch } from '@/store'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export function useSorter() {
  const listOptions = useSelector(selectTrafficAreasListOptions)
  const listStructure = useSelector(selectTrafficAreasListStructure)
  const { editing } = useEditingStateWithCtx('trafficArea')
  const dispatch = useAppDispatch()

  const [field, setField] = useState(() => listOptions.sort[0].field)
  const [direction, setDirection] = useState(() => listOptions.sort[0].direction)

  useEffect(() => {
    if (!listOptions.sort) return
    if (listOptions.sort[0].field === field && listOptions.sort[0].direction === direction) return

    dispatch(
      setListOptions({
        category: 'trafficAreas',
        options: {
          ...listOptions,
          sort: [
            {
              field,
              direction,
            },
          ],
        },
      }),
    )
  }, [dispatch, field, direction, listOptions])

  return {
    editing,
    field,
    setField,
    direction,
    setDirection,
    noEntries:
      listStructure.totalItems === 0 ||
      // This is an hack related the traffic areas list.
      // Since the selection of a traffic profile is a filter itself, we need to check for additional filters
      // to show the no results view or the no entries view
      (listStructure.shownItems === 0 && listOptions.search.query === ''),
  }
}
